import { Component, OnInit, inject } from '@angular/core';
import { CommonMigFormComponent } from '../../components/abstract/common-mig-form.component';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { User } from '@models/account/user.model';
import { Validators } from '@angular/forms';
import { createUrlTreeFromSnapshot } from '@angular/router';

@Component({
  selector: 'app-form-type-page',
  templateUrl: './form-type-page.component.html',
  styleUrls: ['./form-type-page.component.scss'],
})
export class FormTypePageComponent
  extends CommonMigFormComponent
  implements OnInit
{
  user: User;
  protected api: CommonVerbsApiService = inject(CommonVerbsApiService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.module.step = 3;
    this.group = this.builder.group({
      careTypeId: [null, [Validators.required]],
    });

    this.unsubscribe.push(
      this.module.onSubmit.subscribe(() => {
        this.onSubmit();
      })
    );
    this.unsubscribe.push(
      this.module.user$.subscribe(user => {
        if (user) {
          this.user = user;
        }
      })
    );
  }

  onSubmit() {
    this.submit = true;
    this.group.markAsTouched();
    if (this.group.valid) {
      this.api
        .post(`users/${this.user.id}/care-type`, {
          careType: this.group.get('careTypeId')?.value,
        })
        .subscribe({
          next: () => {
            const urlTree = createUrlTreeFromSnapshot(this.route.snapshot, [
              this.group.get('careTypeId')?.value,
            ]);
            this.router.navigateByUrl(urlTree).then();
          },
          error: () =>
            this.toastr.error(
              'An error occurred on save. Try again in a few seconds.'
            ),
        });
    }
  }
}
